export default "__VITE_ASSET__BFqnLHCT__"